import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setLayoutDashboardTitle } from "../../../store/ui-slice";
import OwnerDashboardMain from "./component/OwnerDashboardMain";

const title = "Owner Dashboard";

const OwnerDashboardMainPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLayoutDashboardTitle({ title }));
  }, []);

  return <OwnerDashboardMain />;
};

export default OwnerDashboardMainPage;
